import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const reDownloadQrBatchApiImpl = async (_: { zipToken: string, stablishmentId: string }): Promise<Either<ErrorEntity, void>> => {
    try {
        const hostUrl = di.get<HostApi>(HostApiName).url;
        const relativeUrl = `/qrcodes/redownloadqrs?zip_token=${_.zipToken}&stablishment_id=${_.stablishmentId}`;
        const token = di.get<HostApi>(HostApiName).getToken();

        // Fetch the response with token
        const response = await fetch(`${hostUrl}${relativeUrl}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Parse JSON response to get download_url
        const data = await response.json();

        if (!data.download_url) {
            throw new Error('No download URL provided in response');
        }

        // Fetch the actual file with authorization headers
        
        const fileResponse = await fetch(data.download_url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!fileResponse.ok) {
            if (fileResponse.status === 401) {
                throw new Error('Token no válido o expirado. Por favor, inicia sesión nuevamente.');
            }
            throw new Error(`Error downloading file: ${fileResponse.status}`);
        }

        // Get the file blob
        const blob = await fileResponse.blob();
        
        // Create download link with blob URL
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', `qr_batch_${_.zipToken}.zip`);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);

        return right(undefined);
    } catch (error) {
        console.error('Error downloading QR batch:', error);
        
        // Handle specific authentication error
        if (error instanceof Error && error.message.includes('Token no válido')) {
            return left({
                code: error.message,
            });
        }
        
        return left({
            code: "Error descargando lote de QRs",
        });
    }
};

export default reDownloadQrBatchApiImpl;